module.exports = __webpack_public_path__ + "img/8.879c625d.jpg";